function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M73.976 67.866H4.958a4.91 4.91 0 0 1-4.952-4.888V15.22c-.003-2.694 2.188-4.951 4.949-4.951h69.024c2.696 0 4.954 2.196 4.954 4.954v47.691c-.064 2.822-2.258 4.952-4.954 4.952h-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#221F1F",
  opacity: 0.1,
  d: "M9.845 67.866l29.527-21.609.186-1.257L9.153 23.118l-.064 43.686z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D44C3D",
  d: "M4.952 67.866C2.194 67.866 0 65.733 0 62.978V15.156c0-2.758 2.193-3.258 4.95-3.258 2.759 0 4.955.564 4.955 3.258v52.707H4.952v.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D44C3D",
  d: "M4.952 12.651c3.511 0 4.2 1.065 4.2 2.508v52.014h-4.2a4.198 4.198 0 0 1-4.198-4.197V15.159c-.067-1.504.684-2.508 4.198-2.508zm0-.69C2.194 11.962 0 12.527 0 15.16v47.755a4.881 4.881 0 0 0 4.95 4.952h4.955V15.16c-.064-2.694-2.196-3.2-4.954-3.2v.003zm69.024.69c3.2 0 4.2.629 4.2 2.386V63.04c0 2.318-1.882 4.2-4.2 4.2h-4.198V15.034c-.064-1.818 1-2.383 4.198-2.383zm0-.69c-2.758 0-4.951.379-4.951 3.073V67.93h4.95a4.927 4.927 0 0 0 4.955-4.954V14.97c-.064-2.697-2.257-3.011-4.954-3.011v.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D44C3D",
  d: "M73.976 67.866h-4.951v-52.83c0-2.757 2.193-3.074 4.95-3.074 2.759 0 4.955.378 4.955 3.072V63.04a4.937 4.937 0 0 1-4.954 4.829v-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#221F1F",
  d: "M52.85 67.866L.437 17.227l2.758 1.129 36.491 26.269L78.93 15.848V63.04a4.91 4.91 0 0 1-4.951 4.89l-21.129-.064z",
  opacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D44C3D",
  d: "M39.372 46.318L2.13 19.293C-.063 17.666-.692 14.528.94 12.34a5.062 5.062 0 0 1 7.02-1.07l31.476 22.885L71.09 10.958c2.196-1.632 5.265-1.129 6.895 1.126 1.632 2.193 1.128 5.265-1.126 6.894L39.372 46.321v-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D44C3D",
  d: "M73.976 10.769c1.315 0 2.633.628 3.447 1.757a4.276 4.276 0 0 1-.94 5.894l-37.11 27.022-36.8-26.708C.683 17.355.186 14.658 1.501 12.84a4.2 4.2 0 0 1 3.508-1.818c.943 0 1.821.25 2.51.815l31.41 22.821.442.254.437-.254 31.598-23.197a5.237 5.237 0 0 1 2.569-.692zm0-.75c-1 0-2.069.253-2.883.94L39.43 34.154 7.9 11.211a4.858 4.858 0 0 0-2.947-.942c-1.565.064-3.136.756-4.073 2.068-1.57 2.193-.942 5.265 1.251 6.895l37.242 27.086 37.49-27.334a4.983 4.983 0 0 0 1.125-6.894c-1-1.321-2.504-2.072-4.011-2.072z"
}));

var SvgGmailIco = function SvgGmailIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGmailIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gmail_ico.5c267439.svg";
export { ForwardRef as ReactComponent };